import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Header } from "@/components/Header";
import { KnowledgeConnections } from "@/components/knowledge/KnowledgeConnections";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { JsonLd } from "@/components/JsonLd";
import { generateCanonicalUrl } from "@/utils/seoHelpers";

const GoogleAdsMemorialPage = () => {
  const [language] = useState<'es' | 'en'>('es');
  const canonical = generateCanonicalUrl('/google-ads-memorial');

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Google Ads en Memorial Houston",
    areaServed: {
      "@type": "Place",
      name: "Memorial, Houston, TX"
    },
    provider: { "@id": "https://luisroc.com/#organization" },
    description: "Gestión experta de Google Ads en Memorial, Houston. Campañas locales rentables para atraer clientes."
  };

  return (
    <>
      <Helmet>
        <html lang={language} />
        <title>Google Ads Memorial Houston TX | PPC Local – Luis ROC</title>
        <meta name="description" content="Gestión experta de Google Ads en Memorial, Houston. Campañas locales rentables para atraer clientes hoy mismo. Reunión inicial gratuita." />
        <meta name="keywords" content="Google Ads Memorial, publicidad Google Memorial, PPC Memorial Houston, campañas SEM Houston" />
        <link rel="canonical" href={canonical} />
      </Helmet>

      <JsonLd data={serviceSchema} />

      <div className="min-h-screen bg-background">
        <Header language={language} onLanguageChange={() => {}} />
        <main className="container mx-auto px-4 py-16 text-center">
          <h1 className="text-4xl font-bold mb-6">Google Ads en Memorial Houston TX</h1>
          <p className="max-w-2xl mx-auto mb-8 text-muted-foreground">
            Lanza campañas PPC dirigidas al vecindario de Memorial y maximiza el ROI con optimización continua y seguimiento de conversiones.
          </p>
          <Button size="lg" onClick={() => (window.location.href = "/contacto")}>Consulta</Button>
        </main>
        <KnowledgeConnections path="/google-ads-memorial" language={language} />

        <Footer language={language} />
      </div>
    </>
  );
};
export default GoogleAdsMemorialPage;
